module.exports = __webpack_public_path__ + "img/ttl.b8eff5e.png";